"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, type ReactNode } from "react";
interface LazySectionProps {
  children: ReactNode;
  /** Vertical margin around the root for pre-loading. Default "800px 0px" */
  rootMargin?: string;
  /** Minimum height placeholder before the section loads */
  minHeight?: string;
}
export function LazySection(t0) {
  const $ = _c(9);
  const {
    children,
    rootMargin: t1,
    minHeight: t2
  } = t0;
  const rootMargin = t1 === undefined ? "800px 0px" : t1;
  const minHeight = t2 === undefined ? "200px" : t2;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  let t3;
  let t4;
  if ($[0] !== rootMargin) {
    t3 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(t5 => {
        const [entry] = t5;
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      }, {
        rootMargin
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t4 = [rootMargin];
    $[0] = rootMargin;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== children || $[4] !== minHeight || $[5] !== visible) {
    t5 = visible ? children : <div className="px-4 py-12 sm:px-6 sm:py-16" style={{
      minHeight
    }}><div className="mx-auto flex h-full max-w-7xl items-center"><div className="w-full overflow-hidden rounded-2xl border border-slate-100 bg-slate-50/60 p-5 sm:p-8"><div className="mb-6 h-3 w-24 animate-pulse rounded-full bg-teal-100" /><div className="space-y-3"><div className="h-5 w-2/3 animate-pulse rounded-full bg-slate-200/80 sm:w-1/3" /><div className="h-4 w-full animate-pulse rounded-full bg-slate-100" /><div className="h-4 w-4/5 animate-pulse rounded-full bg-slate-100" /></div><div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">{Array.from({
              length: 4
            }).map(_temp)}</div></div></div></div>;
    $[3] = children;
    $[4] = minHeight;
    $[5] = visible;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div ref={ref}>{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(_, index) {
  return <div key={index} className="h-20 animate-pulse rounded-xl bg-white ring-1 ring-slate-100" />;
}